<div class="container">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content [innerHtml]="data.message">
   
  </div>
  <div mat-dialog-actions class="buttonRow">
    <button mat-button mat-dialog-close (click)="onCancel()" class="secondaryBtn">No</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="onConfirm()" class="primaryBtn">Yes</button>
  </div>
</div>